import "./FreeOnlinePostureAssessment.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import ServiceCards from "./sections/ServiceCards";
import HowItWorks from "./sections/HowItWorks";
import IndicadoresDeConfianza from "./sections/IndicadoresDeConfianza";
import JoinTheMva from "./sections/JoinTheMva";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function FreeOnlinePostureAssessmentPage() {
  return <div>
      <Header />
      <HeroBanner />
      <ServiceCards />
      <HowItWorks />
      <IndicadoresDeConfianza />
      <JoinTheMva />
      <FinalCallToAction />
      <Footer />
    </div>;
}